"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any*/
//justification: exposing the same interface as the underlying loggers (console.log, AzureFunctionLogger atm)
Object.defineProperty(exports, "__esModule", { value: true });
